import { render, staticRenderFns } from "./_ListeConsignes.vue?vue&type=template&id=b0880e30&"
import script from "./_ListeConsignes.vue?vue&type=script&lang=ts&"
export * from "./_ListeConsignes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports